import { Dispatch } from 'react'
import { getAccount } from '../../../../global/nav/services/api'
import { AppState } from '../../../../global/store'
import { ApiResponse } from '../../../types'

import {
  DetailsSettingsAction,
  LOAD_ACCOUNT_DETAILS_ERROR,
  LOAD_ACCOUNT_DETAILS_RECEIVED,
  LOAD_ACCOUNT_DETAILS_REQUEST
} from './reducers'

export function loadAccountDetails(accountId: string) {
  return async function (state: AppState, dispatch: Dispatch<DetailsSettingsAction>) {
    try {
      dispatch({
        type: LOAD_ACCOUNT_DETAILS_REQUEST
      })

      const results = await getAccount(accountId)
      const mappedDetails = mapAccountDetails(results.data)

      dispatch({
        type: LOAD_ACCOUNT_DETAILS_RECEIVED,
        accountDetails: mappedDetails
      })
    } catch {
      dispatch({
        type: LOAD_ACCOUNT_DETAILS_ERROR
      })
    }
  }
}

export function mapAccountDetails(data: ApiResponse) {
  return {
    id: data.id,
    name: data.name,
    country: data.country_code,
    timezone: data.timezone,
    createdAt: data.created_at,
    deactivatedAt: data.deactivated_at,
    active: data.active,
    demo: data.demo,
    currency: data.currency
  }
}
